var map = {
	"./autumn-day/cloud-1.png": "1353",
	"./autumn-day/cloud-2.png": "2d7e",
	"./autumn-day/forest-1.png": "afea",
	"./autumn-day/ground.png": "fe8f",
	"./autumn-day/hill-1.png": "4a46",
	"./autumn-day/hill-2.png": "5e59",
	"./autumn-day/house-1.png": "c378",
	"./autumn-day/house-2.png": "581d",
	"./autumn-day/plain.png": "abfb",
	"./autumn-day/plant-1.png": "c375",
	"./autumn-day/plant-2.png": "999a",
	"./autumn-day/sky.png": "ba2b",
	"./autumn-day/statue-1.png": "58a9",
	"./autumn-day/statue-2.png": "b27a",
	"./autumn-night/cloud-1.png": "f055",
	"./autumn-night/cloud-2.png": "d7fd",
	"./autumn-night/forest-1.png": "b313",
	"./autumn-night/ground.png": "ec4f",
	"./autumn-night/hill-1.png": "46de",
	"./autumn-night/hill-2.png": "55d2",
	"./autumn-night/house-1.png": "5e4b",
	"./autumn-night/house-2.png": "3b6d",
	"./autumn-night/plain.png": "faea",
	"./autumn-night/plant-1.png": "b3fd",
	"./autumn-night/plant-2.png": "d148",
	"./autumn-night/sky.png": "f2e9",
	"./autumn-night/statue-1.png": "9c38",
	"./autumn-night/statue-2.png": "0856",
	"./dolmen-day/cloud-1.png": "8eeb",
	"./dolmen-day/cloud-2.png": "6f4f",
	"./dolmen-day/cloud-3.png": "229f",
	"./dolmen-day/ground.png": "df81",
	"./dolmen-day/hill-1.png": "4e4f",
	"./dolmen-day/hill-2.png": "65ed",
	"./dolmen-day/hill-3.png": "4183",
	"./dolmen-day/hill-4.png": "c15a",
	"./dolmen-day/plant-1.png": "286a",
	"./dolmen-day/plant-2.png": "cadd",
	"./dolmen-day/sky.png": "b506",
	"./dolmen-night/cloud-1.png": "5d6e",
	"./dolmen-night/cloud-2.png": "4ac5",
	"./dolmen-night/cloud-3.png": "151a",
	"./dolmen-night/ground.png": "c94a",
	"./dolmen-night/hill-1.png": "f87a",
	"./dolmen-night/hill-2.png": "a274",
	"./dolmen-night/hill-3.png": "01b4",
	"./dolmen-night/hill-4.png": "8569",
	"./dolmen-night/plant-1.png": "a8d8",
	"./dolmen-night/plant-2.png": "fc00",
	"./dolmen-night/sky.png": "6fc5",
	"./temple-day/columns.png": "3e44",
	"./temple-day/ground.png": "a205",
	"./temple-day/roof.png": "4547",
	"./temple-day/sky.png": "4c49",
	"./winter-day/forest.png": "b798",
	"./winter-day/ground.png": "acd7",
	"./winter-day/hill-2.png": "fa5f",
	"./winter-day/hill-3.png": "d3a6",
	"./winter-day/hill-4.png": "e681",
	"./winter-day/hill-5.png": "3418",
	"./winter-day/hill-6.png": "ada8",
	"./winter-day/mountains.png": "fd86",
	"./winter-day/pike.png": "4856",
	"./winter-day/sky.png": "9d08",
	"./winter-night/forest.png": "a370",
	"./winter-night/ground.png": "aca7",
	"./winter-night/hill-2.png": "2bba",
	"./winter-night/hill-3.png": "0aa4",
	"./winter-night/hill-4.png": "7828",
	"./winter-night/hill-5.png": "0591",
	"./winter-night/hill-6.png": "e4ee",
	"./winter-night/mountains.png": "b80f",
	"./winter-night/pike.png": "2e14",
	"./winter-night/sky.png": "c6d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eeb7";